import type { NotificationApiItem } from '../types';

const NOTIFICATION_ACTIONS = new Set([
  'application_status',
  'reco_list_jobs',
  'my_post',
  'post_detail',
  'trending',
  'view_chat',
  'social_profile',
  'social_profile_follower',
  'social_profile_following',
  'book_detail',
  'campaign_detail',
]);

function getAction(item: NotificationApiItem): string | undefined {
  const candidates = [
    item.action,
    item.content.action,
    item.content.actionName,
    item.content.data?.action,
    item.content.templateKey,
  ];

  return candidates.find(
    candidate => candidate && NOTIFICATION_ACTIONS.has(candidate)
  );
}

function getPathSegment(value: string | number | undefined): string | null {
  const normalized = String(value ?? '').trim();

  return normalized ? encodeURIComponent(normalized) : null;
}

export function getNotificationHref(
  item: NotificationApiItem
): string | undefined {
  const action = getAction(item);
  const data = item.content.data;

  switch (action) {
    case 'application_status':
      return '/quan-ly-trang-thai-ung-tuyen';
    case 'reco_list_jobs':
      return '/tai-ung-dung';
    case 'my_post':
    case 'trending':
      return '/thao-luan';
    case 'post_detail': {
      const postId = getPathSegment(data?.postId);

      return postId ? `/thao-luan/${postId}` : undefined;
    }
    case 'view_chat': {
      const chatId = getPathSegment(data?.chatId);

      return chatId ? `/chat/${chatId}` : undefined;
    }
    case 'social_profile':
    case 'social_profile_follower':
    case 'social_profile_following': {
      const authorId = getPathSegment(data?.authorId);

      return authorId ? `/trang-ca-nhan/${authorId}` : undefined;
    }
    case 'book_detail': {
      const bookId = getPathSegment(data?.bookId);

      return bookId ? `/sach/${bookId}` : undefined;
    }
    case 'campaign_detail': {
      const campaignId = getPathSegment(data?.campaignId);

      return campaignId
        ? `/thao-luan/chi-tiet-chien-dich/${campaignId}`
        : undefined;
    }
    default:
      return undefined;
  }
}
